module.exports = __webpack_public_path__ + "img/petstairs09.153b37ec.jpg";